<template>
    <div v-if="displayModal" class="lottie-modal">
        <div class="lottie-modal-overlay" @click="onOverlayClick"></div>
        <div class="lottie-modal-content">
            <!-- 入场动画 -->
            <Lottie
                v-if="startAnimateLink"
                v-show="currentAnimation === ANIMATION_STEP.START"
                ref="startLottiePlayer"
                :path="startAnimateLink"
                :loop="false"
                :autoplay="false"
                :preload="true"
                @lottie-complete="onStartLottieComplete"
            />
            <!-- 循环动画 -->
            <Lottie
                v-show="currentAnimation === ANIMATION_STEP.LOOP || (!startAnimateLink && !endAnimateLink)"
                ref="loopLottiePlayer"
                :path="loopAnimateLink"
                :loop="true"
                :autoplay="false"
                :preload="true"
                @lottie-loop-complete="onLoopLottieComplete"
            />
            <!-- 结束动画 -->
            <Lottie
                v-if="endAnimateLink"
                v-show="currentAnimation === ANIMATION_STEP.END"
                ref="endLottiePlayer"
                :path="endAnimateLink"
                :loop="false"
                :autoplay="false"
                :preload="true"
                @lottie-complete="onEndLottieComplete"
            />
        </div>
    </div>
</template>

<script>
import Lottie from '../Lottie/index.vue';
import { ANIMATION_STEP } from '../../constants/business';
import Defer from '../Defer';

export default {
    name: 'LottieModal',
    components: {
        Lottie
    },
    props: {
        startAnimateLink: {
            type: String,
            default: ''
        },
        loopAnimateLink: {
            type: String,
            default: ''
        },
        endAnimateLink: {
            type: String,
            default: ''
        },
        showClose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentAnimation: ANIMATION_STEP.START, // 当前显示的动画：start, loop, end
            ANIMATION_STEP,
            startCompletePromise: null,
            loopCompletePromise: null,
            endCompletePromise: null,
            isReceived: false,
            displayModal: false
        };
    },
    methods: {
        /**
         * 重置动画状态
         */
        resetAnimationState() {
            this.currentAnimation = ANIMATION_STEP.START;
            this.startCompletePromise = new Defer();
            this.loopCompletePromise = new Defer();
            this.endCompletePromise = new Defer();
            this.isReceived = false;
        },

        /**
         * 播放动画
         * @param {Object} lottiePlayerRef Lottie组件实例
         */
        async playAnimation(lottiePlayerRef, type) {
            this.currentAnimation = type;
            await lottiePlayerRef.isLoadedPromise.promise;
            lottiePlayerRef.goToAndPlay(0);
        },

        /**
         * 播放开场动画和循环动画
         */
        async playStartAndLoopAnimation() {
            this.displayModal = true;
            this.resetAnimationState();
            await this.$nextTick();

            if (!this.startAnimateLink) {
                this.startCompletePromise.resolve();
            } else {
                this.playAnimation(this.$refs.startLottiePlayer, ANIMATION_STEP.START);
                await this.startCompletePromise.promise;
            }

            this.playAnimation(this.$refs.loopLottiePlayer, ANIMATION_STEP.LOOP);
        },

        onStartLottieComplete() {
            if (this.startCompletePromise) {
                this.startCompletePromise.resolve();
            }
        },

        onLoopLottieComplete() {
            if (this.loopCompletePromise && this.isReceived) {
                this.loopCompletePromise.resolve();
            }
        },

        onEndLottieComplete() {
            if (this.endCompletePromise) {
                this.endCompletePromise.resolve();
            }
        },

        /**
         * 播放结束动画并关闭动画弹窗
         */
        async playEndAnimationAndClose() {
            this.isReceived = true;
            await this.loopCompletePromise.promise;
            if (this.endAnimateLink) {
                await this.playAnimation(this.$refs.endLottiePlayer, ANIMATION_STEP.END);
                await this.endCompletePromise.promise;
            }
            this.close();
        },

        /**
         * 关闭弹窗
         */
        close() {
            this.displayModal = false;
        },

        /**
         * 点击遮罩层
         */
        onOverlayClick() {
            if (this.showClose) {
                this.close();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.lottie-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    .lottie-modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.8);
    }

    .lottie-modal-content {
        position: relative;
        z-index: 1;
        max-width: 90vw;
        max-height: 90vh;
    }
}
</style>
